var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.51 5.01L14.55 3.05C13.15 1.65 10.85 1.65 9.45001 3.05L7.49001 5.01C7.10001 5.4 7.10001 6.04 7.49001 6.43L11.3 10.24C11.69 10.63 12.32 10.63 12.71 10.24L16.52 6.43C16.9 6.04 16.9 5.4 16.51 5.01Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.01 7.49001L3.05 9.45001C1.65 10.85 1.65 13.15 3.05 14.55L5.01 16.51C5.4 16.9 6.03 16.9 6.42 16.51L10.23 12.7C10.62 12.31 10.62 11.68 10.23 11.29L6.43 7.49001C6.04 7.10001 5.4 7.10001 5.01 7.49001Z",
    fill: "#292D32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.95 9.45001L18.99 7.49001C18.6 7.10001 17.97 7.10001 17.58 7.49001L13.77 11.3C13.38 11.69 13.38 12.32 13.77 12.71L17.58 16.52C17.97 16.91 18.6 16.91 18.99 16.52L20.95 14.56C22.35 13.15 22.35 10.85 20.95 9.45001Z",
    fill: "#292D32"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49005 18.99L9.45005 20.95C10.8501 22.35 13.1501 22.35 14.5501 20.95L16.5101 18.99C16.9001 18.6 16.9001 17.97 16.5101 17.58L12.7001 13.77C12.3101 13.38 11.6801 13.38 11.2901 13.77L7.48005 17.58C7.10005 17.96 7.10005 18.6 7.49005 18.99Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeading);
export default __webpack_public_path__ + "static/media/heading.3e35118bfad54b0e5096f36a7f1b1783.svg";
export { ForwardRef as ReactComponent };